/* istanbul ignore file */
import { createSelector } from 'reselect'

export const rentalCarContractSelector = (state) => state.rentalCarContract

export const rentalCarContractDataSelector = createSelector(
    rentalCarContractSelector,
    (rentalCarContract) => rentalCarContract.data
)

export const rentalCarContractStatusSelector = createSelector(
    rentalCarContractSelector,
    (rentalCarContract) => rentalCarContract.status
)

export const rentalCarContractErrorSelector = createSelector(
    rentalCarContractStatusSelector,
    (status) => status.error
)

export const rentalCarContractIsLoadingSelector = createSelector(
    rentalCarContractStatusSelector,
    (status) => status.pending
)

export const rentalCarContractLoadedSelector = createSelector(
    rentalCarContractStatusSelector,
    (status) => status.loaded
)

export const rentalCarContractIsAvailableSelector = createSelector(
    rentalCarContractStatusSelector,
    (rentalCarContract) => !!rentalCarContract
)
